
<script>
import { Line,mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins:[reactiveProp],
      name: "chart",

  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
      console.log(this.props)
    this.renderChart(this.chartData, this.options)
  }
}

</script>
